import React from 'react';
import { DefaultButton, IButtonStyles } from '@fluentui/react';

const styles : IButtonStyles = {
    root: {
        backgroundColor: 'transparent',
        color: 'black',
        borderColor: 'transparent',
        width: '100%',
        fontSize: 24,
        height: 48,
    },
    rootHovered: {
        backgroundColor: 'var(--color-primario)',
        color: 'black',
        borderColor: 'var(--color-primario)',
        fontWeight: 'bold',
    },
};

interface IButtonSecondaryComponentProps {
    text: string;
    onClick?: (event: any) => void;
    icon?: string,
};

const ButtonSecondaryComponent = (props: IButtonSecondaryComponentProps) => {
    return (
        <DefaultButton
            type='submit'
            text={props.text}
            onClick={props.onClick}
            iconProps={props.icon ? {
                iconName: props.icon,
            } : {}}
            styles={styles} />
    );
};

export default ButtonSecondaryComponent;
